import axios from "axios";

export class MainService {
  constructor() { }

  async findSettings(urlSiteApi) {
    const response = await axios.get(`${urlSiteApi}/api/setting`);
    return response?.data?.data;
  }
}